export default "__VITE_ASSET__BgjJWaqw__"